// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4t-0";
export var eligibilityCardNotEligible = "_4t-1";